import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authApi } from "../../config/api";
import { toast } from "react-toastify";

export const createToken = createAsyncThunk(
  "add/feedback",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await authApi.post("/manager/tickets/", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Ensures correct handling of files
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Async thunk for get all ticket
export const getHelpDesk = createAsyncThunk(
  "get/all/helpdesk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await authApi.get("/manager/tickets/");
      console.log(response.data, "getHelpDesk");

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for delete ticket
export const deleteHelpDesk = createAsyncThunk(
  "delete/all/helpdesk",
  async (ticket_ids, { rejectWithValue }) => {
    try {
      const response = await authApi.delete(`/manager/tickets/?${ticket_ids}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for rating ticket
export const updateHelpDesk = createAsyncThunk(
  "update/all/helpdesk",
  async ({ ticket_ids, userData }, { rejectWithValue }) => {
    try {
      const response = await authApi.patch(
        `/manager/tickets/${ticket_ids}/update/`,
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const helpdeskSlice = createSlice({
  name: "helpdesk",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(createToken.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createToken.fulfilled, (state, action) => {
        state.status = "create_helpdesk_succeeded";

        toast.success(action.payload?.message);
      })
      .addCase(createToken.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getHelpDesk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getHelpDesk.fulfilled, (state, action) => {
        state.status = "get_all_helpdesk_succeeded";
        state.data = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getHelpDesk.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(deleteHelpDesk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteHelpDesk.fulfilled, (state, action) => {
        state.status = "delete_helpdesk_succeeded";
        toast.success(action.payload?.message);
      })
      .addCase(deleteHelpDesk.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(updateHelpDesk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateHelpDesk.fulfilled, (state, action) => {
        state.status = "update_helpdesk_succeeded";
        toast.success(action.payload?.message);
      })
      .addCase(updateHelpDesk.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      });
  },
});

export default helpdeskSlice.reducer;
